module.exports = __webpack_public_path__ + "img/caret-right-white.0fa52fac.svg";